// Vendors
import { loadStripe } from '@stripe/stripe-js';
// Constants
import { LOAD_STRIPE_PROPS } from './constants/payment-landing.handlers.constants';
// Resolvers
import { initiatePaymentResolver } from '../resolvers/payment-landing.resolvers';
// Translations
import { PAY_NOW } from '../translations/payment-landing.translations';
// Types
import {
  PaymentLandingBuilderHandlersType,
  PaymentLandingMethodsHandlersType,
  PaymentLandingSetupButtonHandlersType,
} from './types/payment-landing.handlers.types';
import { TimerEnum } from '@openbank/ziniaweb-ui-core-models';

const setupPaymentLandingButtonConfigurationHandler = ({
  formatMessage,
  setMainButtonConfiguration,
}: PaymentLandingSetupButtonHandlersType): void => {
  setMainButtonConfiguration(prev => ({
    ...prev,
    children: formatMessage({ id: PAY_NOW }),
  }));
};

const fetchInitiatePaymentDataEventHandler = async ({
  setCardCountry,
  setCardPublicKey,
  setClientSecret,
  setFetching,
  setError,
  setStripePromise,
  ...props
}: PaymentLandingBuilderHandlersType): Promise<void> => {
  const [response, error] = await initiatePaymentResolver();

  if (response && !error) {
    setCardCountry(response.cardCountry);
    setCardPublicKey(response.cardPublicKey);
    setClientSecret(response.cardPayment);
    setStripePromise(loadStripe(response.cardPublicKey, LOAD_STRIPE_PROPS));
    setupPaymentLandingButtonConfigurationHandler({ ...props });
  } else {
    setError(true);
  }
  setTimeout(() => {
    setFetching(false);
  }, TimerEnum.TIMEOUT_ONE_SECOND); // @Por intentar sincronizar la carga del frame
};

const PaymentLandingHandlers = (
  props: PaymentLandingBuilderHandlersType
): PaymentLandingMethodsHandlersType => ({
  handleFetchInitiatePaymentData: () => fetchInitiatePaymentDataEventHandler(props),
});

export { PaymentLandingHandlers };
